import React from 'react';
import { TableCell } from '@mui/material';
import { formatCurrency } from '../../utils/formatNumber';

export default class ConversionCell extends React.Component {
    render() {
        // const mockData = {
        //     "gatewayCurrency": 'UZS',
        //     "conversionRate": 1,
        //     "convertedAmount": '5555555',
        //     "requestCurrency": "UZS",
        //     "requestConversionRate": 1,
        //     "requestConvertedAmount": 10000,
        // };
        // const data = mockData;
        const data = this.props.row || {};
        const conversionFields = this.props.field.conversionFields || [];
        const [conversionRate, convertedAmount, currency] =
            conversionFields.map((key) => data[key]);

        const hasAllValues =
            conversionRate !== null &&
            convertedAmount !== null &&
            currency !== null;

        const baseStyle = this.props.styles || {};
        const variant = this.props.field.variant || 'default'; // 'default' or 'reversed'

        return (
            <TableCell
                key={this.props.field.id}
                align="left"
                sx={{ ...baseStyle }}
            >
                {hasAllValues ? (
                    variant === 'reversed' ? (
                        <>
                            <span>
                                {formatCurrency(convertedAmount, currency)}
                            </span>{' '}
                            <span style={{ color: '#888' }}>x</span>{' '}
                            <span>
                                {conversionRate}
                            </span>
                        </>
                    ) : (
                        <>
                            <span style={{ color: '#888' }}>x</span>{' '}
                            <span>
                                {conversionRate}
                            </span>{' '}
                            <span style={{ color: '#888' }}>=</span>{' '}
                            <span>
                                {formatCurrency(convertedAmount, currency)}
                            </span>
                        </>
                    )
                ) : (
                    <span style={{ color: '#aaa' }}>
                        —
                    </span>
                )}
            </TableCell>
        );
    }
}
